"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBreakpointObject = void 0;
function isBreakpointObject(breakpoints) {
    return Object.keys(breakpoints).includes('sm');
}
exports.isBreakpointObject = isBreakpointObject;
//# sourceMappingURL=styles.js.map